export function toastApiError(data) {
    const defaultMessage = 'Wystąpił błąd przy próbie zapisu.';

    try {
        const errorDetails = JSON.parse(data.responseText),
            message = errorDetails.detail || errorDetails.description || errorDetails.message || defaultMessage,
            code = errorDetails.status || errorDetails.code || 500;

        toast(message, code < 500 ? 'warning' : 'danger');
    } catch (error) {
        toast(defaultMessage);
    }
}

export function toast(message, type = 'danger', timeout = 3E3) {
    const $alert = $(`<div class="alert alert-${type} border-${type}">${message}</div>`);
    $alert.appendTo($('body > .alert-container'));

    let removeToastTimeOut = setTimeout(() => {
        removeToast($alert);
    }, timeout);

    $alert.hover(() => {
        clearTimeout(removeToastTimeOut);
    }, () => {
        removeToastTimeOut = setTimeout(() => {
            removeToast($alert);
        }, timeout);
    });
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

export function translate(message) {
    return $.ajax({
        url: '/api/translate',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({message}),
        dataType: 'json'
    }).then(function (response) {
        return response.message;
    })
}

export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function removeToast($toast) {
    $toast.fadeOut(() => {
        $toast.remove();
    });
}

export function formatPrice(value) {
    return value.toFixed(2).replace('.', ',') + ' zł';
}

$('body').on('click', '.alert-container .alert', (e) => {
    let $alert = $(e.target);

    removeToast($alert);
});
